"use strict";
import { __module as t } from "./index.es443.js";
import { __require as _ } from "./index.es444.js";
import { __require as d } from "./index.es445.js";
var u;
function S() {
  return u ? t.exports : (u = 1, (function(s, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "normalizePathTrailingSlash", {
      enumerable: !0,
      get: function() {
        return f;
      }
    });
    const l = _(), o = d(), f = (n) => {
      if (!n.startsWith("/") || process.env.__NEXT_MANUAL_TRAILING_SLASH)
        return n;
      const { pathname: r, query: a, hash: i } = (0, o.parsePath)(n);
      return process.env.__NEXT_TRAILING_SLASH ? /\.[^/]+\/?$/.test(r) ? "" + (0, l.removeTrailingSlash)(r) + a + i : r.endsWith("/") ? "" + r + a + i : r + "/" + a + i : "" + (0, l.removeTrailingSlash)(r) + a + i;
    };
    (typeof e.default == "function" || typeof e.default == "object" && e.default !== null) && typeof e.default.__esModule > "u" && (Object.defineProperty(e.default, "__esModule", { value: !0 }), Object.assign(e.default, e), s.exports = e.default);
  })(t, t.exports), t.exports);
}
export {
  S as __require
};
//# sourceMappingURL=index.es379.js.map
